export { default } from './UserDaysStatTable2';



// WEBPACK FOOTER //
// ./src/components/UserDaysStat/UserDaysStatTables/UserDaysStatTable2/index.js